"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePrice = resolvePrice;
exports.resolveTax = resolveTax;
function resolvePrice(pricing, mode) {
    switch (mode) {
        case 'DELIVERY':
            return pricing.delivery ?? pricing.base;
        case 'TAKEAWAY':
            return pricing.takeAway ?? pricing.base;
        case 'ONSPOT':
            return pricing.onSpot ?? pricing.base;
    }
}
// R2 : ONSPOT résout le taux « sur place ». La v1 résolvait takeAwayTaxId ici
// (bug historique) ; l'engine et le moteur unique résolvent onSpot.
function resolveTax(taxes, mode) {
    switch (mode) {
        case 'DELIVERY':
            return taxes.delivery ?? taxes.base;
        case 'TAKEAWAY':
            return taxes.takeAway ?? taxes.base;
        case 'ONSPOT':
            return taxes.onSpot ?? taxes.base;
    }
}
